import { isToday, isTomorrow } from "date-fns";
import { TFunction } from "i18next";

import { ThemeType } from "../theme/Theme";
import { BaseTask } from "../model/task/Task";
import { TaskPriority } from "../model/task/types/TaskPriority.enum";
import { TaskKind } from "../model/task/shared/TasksKind.enum";

export const getTaskDeadlineDateAsText = (
  date: Date | undefined,
  t: TFunction,
): string => {
  const now = new Date();

  if (!date) {
    return "";
  }

  const deadline = new Date(date);

  if (isToday(deadline)) {
    return t("common.today");
  }
  if (isTomorrow(deadline)) {
    return t("common.tomorrow");
  }
  if (deadline < now) {
    return t("common.out_due");
  }

  return deadline.toLocaleDateString();
};

export const getTaskDeadlineColor = (task: BaseTask): keyof ThemeType => {
  const now = new Date();

  if (!task?.deadline) {
    return "gray";
  }

  const deadline = new Date(task.deadline);

  if (isToday(deadline)) {
    return "warning";
  } else if (deadline < now) {
    return "danger";
  } else if (isTomorrow(deadline)) {
    return "success";
  }

  return "success";
};

export const getTaskPriorityColor = (priority?: TaskPriority) => {
  switch (priority) {
    case TaskPriority.HIGH:
      return "danger";
    case TaskPriority.MEDIUM:
      return "warning";
    case TaskPriority.LOW:
    default:
      return "success";
  }
};

export const getTaskKindColor = (kind?: TaskKind) => {
  switch (kind) {
    case TaskKind.CONTACT:
      return "main";
    case TaskKind.KANBAN:
      return "lightAccent";
    case TaskKind.ORPHAN:
      return "warning";
    case TaskKind.LEAD:
    default:
      return "darkerSub";
  }
};
